import EXTERNAL_APPS from './externalApps';

import Util from './../util';

export function legacyPage(permission, name) {
    const config = {
        id: permission,
        name,
        showSidebar: false,
        children: false
    };

    const methods = {
        get: () => config,
        template(value) {
            config.template = value;
            return methods;
        },
        sidebar(value) {
            config.sidebar = value;
            return methods;
        },
        disabledFilters(value) {
            config.disabledFilters = value;
            return methods;
        },
        headerButtons(value) {
            config.headerButtons = value;
            return methods;
        },
        options(value) {
            Object.assign(config, value);
            return methods;
        },
        showSidebar() {
            config.showSidebar = true;
            return methods;
        },
        kpiFilterDateIncludeToday() {
            config.kpiFilterDateIncludeToday = true;
            return methods;
        }
    };

    return methods;
}

export function page(permission, name, labels = undefined) {
    const config = {
        id: permission,
        name,
        children: false,
        labels
    };

    const methods = {
        get: () => config,
        headerButtons(value) {
            config.headerButtons = value;
            return methods;
        }
    };
    return methods;
}

export function simplePermission(permission, name) {
    return {
        id: permission,
        name,
        children: false,
        noview: true
    };
}

export function externalApp(permission, name) {
    return {
        id: permission,
        name,
        iframeUrl: EXTERNAL_APPS[permission],
        children: false
    };
}

export function addPermissionGroup(permissionId, name, additionalAllowedPermissions = []) {
    return {
        ...externalApp(permissionId, name),
        additionalAllowedPermissions
    };
}

export function group(name, children) {
    return {
        id: Util.string.uuid(),
        name,
        children
    };
}

export function legacyTab(permission, translationKey) {
    const config = {
        id: permission,
        title: translationKey,
        href: '',
        icon: '',
        template: 'views/genericSection.html',
        headerButtons: {
            filters: false,
            incidents: false
        }
    };

    const methods = {
        get: () => config,
        href(value) {
            config.href = value;
            return methods;
        },
        icon(value) {
            config.icon = value;
            return methods;
        },
        template(value) {
            config.template = value;
            return methods;
        },
        headerButtons(value) {
            config.headerButtons = value;
            return methods;
        }
    };

    return methods;
}

export function tab(permission, translationKey) {
    const config = {
        id: permission,
        title: translationKey,
        href: '',
        icon: '',
        headerButtons: {
            filters: false,
            incidents: false
        }
    };

    const methods = {
        get: () => config,
        href(value) {
            config.href = value;
            return methods;
        },
        icon(value) {
            config.icon = value;
            return methods;
        },
        options(value) {
            Object.assign(config, value);
            return methods;
        },
        externalApp(id) {
            config.iframeUrl = EXTERNAL_APPS[id];
            return methods;
        }
    };

    return methods;
}
